import {
  Body,
  FileContent,
  Loader,
  Stack,
} from "@dbn/omnichannel-design-system-g4p";
import { palette } from "@dbn/omnichannel-design-system-g4p/lib/styleConstants";
import { RuntimeLocaleKey, useFormatMessage } from "../intl";
import { ImageViewer } from "../Common/DocumentViewer/DocumentViewer";
import { useCommand } from "../useAPI";
import * as api from "./api";
import { DigitalIdClientIdentified } from "./api";
import { useEffect, useState } from "react";
import { pipe } from "fp-ts/function";
import { taskEither } from "fp-ts";
import { SuccessLargeIcon } from "@g4p/react-styleguide-library";

type Props = {
  onClientIdentified: () => unknown;
};

export function DigitalIdClientProfile({ onClientIdentified }: Props) {
  const formatMessage = useFormatMessage();
  const [
    clientIdentified,
    setClientIdentified,
  ] = useState<DigitalIdClientIdentified>();
  const getClientIdentified = useCommand(api.digitalIdClientIdentified);

  useEffect(() => {
    pipe(
      getClientIdentified(),
      taskEither.map(r => {
        setClientIdentified(r);
        onClientIdentified();
      })
    )();
  }, []);

  if (!clientIdentified) {
    return (
      <Loader
        ariaLabelMessage={formatMessage(
          "generic.loading.alt" as RuntimeLocaleKey
        )}
      />
    );
  }

  return (
    <>
      <Stack units={4} column hAlignContent="center">
        <SuccessLargeIcon
          style={{
            width: 72,
            height: 72,
            color: palette.success900,
          }}
        />
        <Body size="large" weight="bold">
          {formatMessage("DigitalId.ClientIdentified")}
        </Body>
        <ImageViewer
          type="image/png"
          name="clientProfile"
          data={clientIdentified.photo as FileContent}
        />
      </Stack>
    </>
  );
}
